import { render } from "./QuestionsTable.vue?vue&type=template&id=3235d3e9&scoped=true"
import script from "./QuestionsTable.vue?vue&type=script&lang=js"
export * from "./QuestionsTable.vue?vue&type=script&lang=js"

import "./QuestionsTable.vue?vue&type=style&index=0&id=3235d3e9&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3235d3e9"]])

export default __exports__